import React, { Dispatch, SetStateAction } from "react";
import Activity from "../Activity/Activity";
import { humanize } from "../../../../../../utils";
import moment from "moment";
import { HStack, Tag, Text, VStack } from "@chakra-ui/react";
import { AppointmentIcon } from "../../../../../icons/svg";

type SingleAppointmentCardProps = {
  item: any;
  setClickedRecord: Dispatch<SetStateAction<any>>;
  openAppointmentDrawer?: () => void;
  onDeleteClick?: () => void;
  isEditable?: boolean;
  isAppointmentUpdateAllowed: boolean;
};

function SingleAppointmentCard({
  item,
  setClickedRecord,
  openAppointmentDrawer,
  onDeleteClick,
  isEditable,
  isAppointmentUpdateAllowed,
}: SingleAppointmentCardProps) {
  return (
    <Activity
      key={item.id}
      id={item.id}
      handleClick={() => { 
        isAppointmentUpdateAllowed && isEditable && setClickedRecord(item);
      }}
      title={item?.details?.title}
      dateAndTime={moment(item.details.start_time).format(
        "dddd MMM DD YY • hh:mm a"
      )}
      icon={<AppointmentIcon color="var(--grey-800)" />}
      isEditible={isAppointmentUpdateAllowed && isEditable && item?.details?.status == "appointment_set"}
      isDeletable={isAppointmentUpdateAllowed && isEditable && item?.details?.status == "appointment_set"}
      onEditClick={() => { openAppointmentDrawer && openAppointmentDrawer(); }}
      onDeleteClick={() => { onDeleteClick && onDeleteClick(); }}
      content={
        <>
          <VStack alignItems="flex-start" gap="0.25rem">
            <HStack gap="0.25rem">
              <Text textStyle="h6" fontWeight="600">
                Created At:
              </Text>
              <Text color="var(--primary-800)" textStyle="h6" fontWeight="500">
                {moment(item?.created_at).format("dddd MMM DD YY • hh:mm a")}
              </Text>
            </HStack>
            {
              item?.details?.updated_by ? (
                <HStack gap="0.25rem">
                  <Text textStyle="h6" fontWeight="600">
                    Updated By:
                  </Text>
                  <Text color="var(--grey-800)" textStyle="h6" fontWeight="500">
                    {item?.details?.updated_by?.user_name}
                  </Text>
                </HStack>
              ) : (
                <HStack gap="0.25rem">
                  <Text textStyle="h6" fontWeight="600">
                    Created By:
                  </Text>
                  <Text color="var(--grey-800)" textStyle="h6" fontWeight="500">
                    {item?.details?.created_by?.name}
                  </Text>
                </HStack>
              )
            }
            <HStack gap="0.25rem">
              <Text textStyle="h6" fontWeight="600">
                Status:
              </Text>
              {
                item?.details?.status == "rescheduled" ? (
                  <Tag colorScheme="blue" size="sm">
                    {humanize(item?.details?.status)}
                  </Tag>
                ) :
                item?.details?.status == "deleted" ? (
                  <Tag colorScheme="red" size="sm">
                    {humanize(item?.details?.status)}
                  </Tag>
                ) : (
                  <Text color="var(--grey-800)" textStyle="h6" fontWeight="500">
                    {humanize(item?.details?.status)}
                  </Text>
                ) 
              }
            </HStack>
            {
            item?.details?.reason &&
            <HStack gap="0.25rem">
              <Text textStyle="h6" fontWeight="600">
                Reason:
              </Text>
              <Text color="var(--grey-800)" textStyle="h6" fontWeight="500">
                {humanize(item?.details?.reason)}
              </Text>
            </HStack>
            }
          </VStack>
        </>
      }
    />
  );
}

export default SingleAppointmentCard;
